import { gql, useMutation, useLazyQuery } from '@apollo/client';
import middlewareClient from '../apollo/middlewareClient';

export const useOrdersQuery = (limit = 3) => {
  const ORDERS_QUERY = gql`
    query Orders($input: OrdersInput!) {
      orders(input: $input) {
        id
        createdAt
        updatedAt
        shopifyCustomerId
        number
        status
        shopifyOrder {
          id
          billingAddressMatchesShippingAddress
          cancelReason
          cancelledAt
          closed
          closedAt
          confirmed
          createdAt
          currencyCode
          customerLocale
          displayFinancialStatus
          edited
          displayFulfillmentStatus
          email
          estimatedTaxes
          estimatedTaxes
          fullyPaid
          name
          note
          phone
          presentmentCurrencyCode
          processedAt
          requiresShipping
          subtotalLineItemsQuantity
          tags
          taxesIncluded
          totalWeight
          unpaid
          updatedAt
          lineItems {
            edges {
              node {
                name
                title
                fulfillmentStatus
                product {
                  featuredImage {
                    id
                    src
                  }
                }
              }
            }
          }
          billingAddress {
            address1
            address2
            province
            provinceCode
            city
            zip
            firstName
            lastName
            phone
          }
          shippingAddress {
            address1
            address2
            province
            provinceCode
            city
            zip
            firstName
            lastName
            phone
          }
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
          transactions {
            accountNumber
            formattedGateway
            gateway
            kind
            paymentIcon {
              altText
            }
          }
          fulfillments {
            trackingInfo {
              url
              company
              number
            }
          }
        }
      }
    }
  `;

  return useLazyQuery(ORDERS_QUERY, {
    variables: { input: { limit } },
    client: middlewareClient,
  });
};

export const useProductIdsQuery = (limit = 10) => {
  const ORDERS_QUERY = gql`
    query OrderProductIds($input: OrdersInput!) {
      orders(input: $input) {
        shopifyOrder {
          lineItems {
            edges {
              node {
                variant {
                  id
                }
              }
            }
          }
        }
      }
    }
  `;

  return useLazyQuery(ORDERS_QUERY, {
    variables: { input: { limit } },
    client: middlewareClient,
  });
};

export const useCancelOrderMutation = () => {
  const CANCEL_ORDER_MUTATION = gql`
    mutation CancelOrder($input: CancelOrderInput!) {
      cancelOrder(input: $input) {
        order {
          id
          status
        }
      }
    }
  `;

  return useMutation(CANCEL_ORDER_MUTATION, {
    client: middlewareClient,
  });
};

export default {
  useCancelOrderMutation,
  useOrdersQuery,
  useProductIdsQuery,
};
